import { ORDER_COMMENT_CHECKBOXES } from '../constants/order';

import { bonusesOrDefaultDTO } from './bonusesOrDefaultDTO';
import { commentOrDefaultDTO } from './commentOrDefaultDTO';
import { jointOrderDTO } from './jointOrderDTO';
import { priceInfoOrDefaultDTO } from './priceInfoOrDefaultDTO';

import type { OrderStateType } from './types';

export const orderDTO = (data: unknown): OrderStateType => {
  if (data && typeof data === 'object') {
    return {
      isCreating:
        'isCreating' in data && typeof data.isCreating === 'boolean'
          ? data.isCreating
          : false,
      jointOrder:
        'jointOrder' in data && typeof data.jointOrder === 'object'
          ? jointOrderDTO(data.jointOrder)
          : {
              ordersAmount: 0,
              firstOrderNumber: 0,
              isFirstOrder: null,
            },
      isProcessed:
        'isProcessed' in data && typeof data.isProcessed === 'boolean'
          ? data.isProcessed
          : false,
      isPrebuilt:
        'isPrebuilt' in data && typeof data.isPrebuilt === 'boolean'
          ? data.isPrebuilt
          : false,
      isClientConfirmed:
        'isClientConfirmed' in data &&
        typeof data.isClientConfirmed === 'boolean'
          ? data.isClientConfirmed
          : false,
      bonuses: bonusesOrDefaultDTO('bonuses' in data ? data.bonuses : null),
      isTouristsConfirmed:
        'isTouristsConfirmed' in data &&
        typeof data.isTouristsConfirmed === 'boolean'
          ? data.isTouristsConfirmed
          : false,
      showOrderErrorPopup:
        'showOrderErrorPopup' in data &&
        typeof data.showOrderErrorPopup === 'boolean'
          ? data.showOrderErrorPopup
          : false,
      priceInfo: priceInfoOrDefaultDTO(
        'priceInfo' in data ? data.priceInfo : null,
      ),
      isFinished:
        'isFinished' in data && typeof data.isFinished === 'boolean'
          ? data.isFinished
          : false,
      isPrebuildFetching:
        'isPrebuildFetching' in data &&
        typeof data.isPrebuildFetching === 'boolean'
          ? data.isPrebuildFetching
          : false,
      isProcessing:
        'isProcessing' in data && typeof data.isProcessing === 'boolean'
          ? data.isProcessing
          : false,
      isCreated:
        'isCreated' in data && typeof data.isCreated === 'boolean'
          ? data.isCreated
          : false,
      comment: commentOrDefaultDTO('comment' in data ? data.comment : null),
      discountMethods: [],
      discountPrice: 0,
      discountType: null,
      fullPrice: 0,
      insurancePrice: 0,
      orderExtras: [],
    };
  }

  return {
    isClientConfirmed: false,
    isTouristsConfirmed: false,
    priceInfo: [],
    isCreating: false,
    isCreated: false,
    isProcessing: false,
    isProcessed: false,
    isFinished: false,
    isPrebuildFetching: false,
    isPrebuilt: false,
    discountMethods: [],
    discountPrice: 0,
    discountType: null,
    fullPrice: 0,
    showOrderErrorPopup: false,
    comment: {
      text: '',
      checkboxes: ORDER_COMMENT_CHECKBOXES,
    },
    jointOrder: {
      ordersAmount: 0,
      firstOrderNumber: 0,
      isFirstOrder: null,
    },
    bonuses: {
      cashback_identifier: null,
      bonuses_absolut: null,
      bonus_total: 0,
      fuelfree_bonuses_relative: 0,
      max_value: null,
      promotion_fixed: null,
      promotion_value: 0,
    },
    insurancePrice: 0,
    orderExtras: [],
  };
};
